import { render, staticRenderFns } from "./ImposeHtml.vue?vue&type=template&id=0da56804"
import script from "./ImposeHtml.vue?vue&type=script&lang=ts"
export * from "./ImposeHtml.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports